import { render, staticRenderFns } from "./homeComponent.vue?vue&type=template&id=5ed29680&scoped=true"
import script from "./homeComponent.vue?vue&type=script&lang=js"
export * from "./homeComponent.vue?vue&type=script&lang=js"
import style0 from "./homeComponent.vue?vue&type=style&index=0&id=5ed29680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed29680",
  null
  
)

export default component.exports